import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useVModel } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    avatar: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props as {
    label: string
    avatar: string
    modelValue: boolean
}





const checked = useVModel(props, 'modelValue')

return (_ctx: any,_cache: any) => {
  const _component_base_checkbox = _resolveComponent("base-checkbox")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (checked.value = !_unref(checked)), ["stop"])),
    class: "h-13 flex items-center space-x-2.5 cursor-pointer"
  }, [
    _createVNode(_component_base_checkbox, {
      modelValue: _unref(checked),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_q_avatar, {
      rounded: "",
      size: "30px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_img, {
          src: __props.avatar,
          "no-spinner": "",
          "no-transition": ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }),
    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
  ]))
}
}

})